import React, { useEffect, useState } from 'react'
import './ProductoDetalleTamano.scss'
import { DobleGuion } from './DobleGuion';
import { useNavigate } from 'react-router-dom';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { connect } from 'react-redux'

const ProductoDetalleTamano = (props) => {
    const navigate = useNavigate();
    const { producto, variaciones, history } = props

    const [variations, setVariations] = useState(variaciones)

    useEffect(() => {
        let productVariations = []
        for (let i = 0; i < variaciones.length; i++) {
            const product = variaciones[i];
            if ((product.UnidadesPack !== '' && product.UnidadesPack !== '-') ||
                (product.UnidadesPallet !== '' && product.UnidadesPallet !== '-') ||
                (product.UVenta2021Suelto !== '' && product.UVenta2021Suelto !== '-')) {
                //debug
                // if (product.Diametro.toLowerCase().indexOf('x') > -1) {
                //     const aux = product.Diametro.split('x')[0]
                //     product.Diametro = aux
                // }
                productVariations.push(product)
            }
        }
        productVariations = productVariations.sort((a, b)=>{
            return parseInt(a.Diametro) - parseInt(b.Diametro)
        })
        setVariations(productVariations)
    }, [variaciones])

    const handleSelectChage = (event, data) => {
        navigate(`/producto/${event.target.value}`)
    }

    return (
        <React.Fragment>
            { variations.length > 1 &&
                <div className="producto-detalle-tamano">
                    <div className="titulo"><p>Elige el tamaño</p> <DobleGuion /></div>
                    <div className="select">
                        <Select
                            MenuProps={{
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left"
                                },
                                transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left"
                                },
                                getContentAnchorEl: null
                            }}
                            IconComponent={ArrowForwardIosIcon}
                            value={producto.ID}
                            id="select"
                            onChange={handleSelectChage}>
                            {
                                variations.map((item, index) => {
                                    {
                                        return (
                                            item.Diametro.toLowerCase().indexOf('set/') > -1 ?
                                                <MenuItem key={index} value={item.ID}>{!Number.isNaN(parseInt(item.Diametro)) ? parseInt(item.Diametro).toFixed(0) : item.Diametro}</MenuItem>
                                                :
                                                <MenuItem key={index} value={item.ID}>{!Number.isNaN(parseInt(item.Diametro)) ? parseInt(item.Diametro).toFixed(0) : item.Diametro} cm</MenuItem>
                                        )
                                    }
                                })
                            }
                        </Select>

                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default connect(null, null)(ProductoDetalleTamano)